/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ImageCropResult, ImageCropperData } from '../../models/images/image-crop.model';
import { ImageCropDialogBase } from './image-crop-dialog.base';

@Component({
  selector: 'ptl-image-crop-dialog',
  templateUrl: './image-crop-dialog.component.html',
  styleUrls: ['./image-crop-dialog.component.scss'],
})
export class ImageCropDialogComponent extends ImageCropDialogBase {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImageCropperData,
    private dialogRef: MatDialogRef<ImageCropDialogComponent>,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  protected get cropData(): ImageCropperData {
    return this.data;
  }

  protected detectChanges(): void {
    this.cdr.detectChanges();
  }

  protected closeWith(result?: ImageCropResult): void {
    this.dialogRef.close(result);
  }
}
